export * from '@primeuix/themes/nora/multiselect';
export { default } from '@primeuix/themes/nora/multiselect';
